import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Solution(props) {
    return (
        <div className="services_solution  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="Your Campaign">
                            <h2>Beat The Competition, Kickstart Your Digital Campaign</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                        <p>TekRevol assists startups and new businesses in paving their way. Our digital transformation
                            consulting service is crafted for those seeking to step into the digital era, with each step
                            taken the right way by skipping the trial-and-error phase in a short time.</p>
                        <p>Our digital transformation experts go the extra mile to build strategies for businesses after
                            assessing their business objectives, growth patterns, and ambitions. Covering all the
                            possibilities, we devise strategies that are bound to deliver you the success you are
                            after.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Solution;